import { FC } from 'react'
import { useParams } from 'react-router-dom'

import { IndicatorsList, Widget } from '@factorialco/f0-react/dist/experimental'
import { FinanceValueObjectsContactTypeEnum } from 'generated/resources/datatable.graphql'
import {
  ContactPurchaseOrderWidgetDocument,
  ContactPurchaseOrderWidgetQuery,
} from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { buildWidget } from 'modules/core/lib/widgets'

const prepareData = (data: ContactPurchaseOrderWidgetQuery) => {
  const totalCount = data.procurement?.total?.aggregate?.count ?? 0
  const closedCount = data.procurement?.closed?.aggregate?.count ?? 0

  return {
    title: i18n.t('finance.contacts.contact_details.widgets.purchase_orders.title'),
    total: {
      label: i18n.t('finance.contacts.contact_details.widgets.purchase_orders.total'),
      content: totalCount.toString(),
    },
    closed: {
      label: i18n.t('finance.contacts.contact_details.widgets.purchase_orders.closed'),
      content: closedCount.toString(),
    },
  }
}

type PreparedData = ReturnType<typeof prepareData>

const buildPurchaseOrderWidgetComponent = (contactType: FinanceValueObjectsContactTypeEnum) => {
  const PurchaseOrderWidgetComponentWithContactType: FC<{ data: PreparedData }> = ({
    data: { title, total, closed },
  }) => {
    const { navigation } = useNavigation()
    const { contactId } = useParams()

    const destinationUrl =
      contactType === 'client'
        ? navigation.finance.sales.clients.contactId.purchaseOrders.fullPath({
            contactId: String(contactId),
          })
        : navigation.finance.spending.vendors.contactId.purchaseOrders.fullPath({
            contactId: String(contactId),
          })

    const link = {
      url: destinationUrl,
      title: title,
    }

    return (
      <Widget
        header={{
          title,
          link,
        }}
      >
        <IndicatorsList
          items={[
            {
              ...total,
            },
            {
              ...closed,
            },
          ]}
        />
      </Widget>
    )
  }

  return PurchaseOrderWidgetComponentWithContactType
}

export const buildContactsPurchaseOrdersWidget = (
  contactType: FinanceValueObjectsContactTypeEnum
) =>
  buildWidget({
    id: 'contactsPurchaseOrders',
    document: ContactPurchaseOrderWidgetDocument,
    prepareData,
    component: buildPurchaseOrderWidgetComponent(contactType),
  })
